import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { TENURES } from "../constants/MySubscriptions.tenures";
import {
  handleChangeLicenseTenure,
  handleSetPlans,
} from "../utils/store.utils";

export const useMySubscriptionsStore = create(
  persist(
    (set) => ({
      licensesSection: { tenure: TENURES.MONTHLY, plans: [] },
      setTenure: handleChangeLicenseTenure(set),
      setPlans: handleSetPlans(set),

      activePlanName: "",
      setActivePlanName: (value) => set({ activePlanName: value }),

      activePlanData: {},
      setActivePlanData: (value) => set({ activePlanData: value }),

      showUpgradePlanModal: false,
      setShowUpgradePlanModal: (value) => set({ showUpgradePlanModal: value }),

      ctaAction: null,
      setCtaAction: (value) => set({ ctaAction: value }),
    }),
    {
      name: "subscription_storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
